document.addEventListener('DOMContentLoaded', ()=>{
  if ( document.querySelectorAll('.chartMarkets__ingredient_aboutLists').length > 0 ){
    new Swiper('.chartMarkets__ingredient_aboutLists.swiper', {
        spaceBetween: 0,
        mousewheel: {forceToAxis: true,thresholdDelta:35},            
        allowTouchMove: true,
        freeMode: true,
        slidesPerView: 'auto',
        grabCursor: true,
        keyboard: {enabled: true},        
        navigation: {
            nextEl: '#swiper-button-next-unique',
            prevEl: '#swiper-button-prev-unique',
        },
        pagination: {
          el: '#swiper-pagination-unique',
          clickable: true
        } 
    }); 
  }
  if( document.querySelectorAll('.backto__info').length > 0 ){
    document.querySelector('.backto__info').addEventListener('click', (elm)=>{
      elm.preventDefault();
      if (document.referrer != ''){
        document.location.href = document.referrer;
      }else if( elm.target.getAttribute('href') != null ){
        document.location.href = elm.target.getAttribute('href');
      }else{
        document.location.href = '/collections/all';
      }
    })
  }

  document.querySelectorAll('.actions_video_btn').forEach((elm)=>{
      elm?.querySelector('.action--play')?.addEventListener('click', (target)=>{
          target.preventDefault();
          if ( target.target.closest('.page__info__bannerimage').classList.contains('onlyshowMob') ){
              document.querySelector('.page__info__bannerimage.onlyshowDesk').querySelector('video').muted = true;
              document.querySelector('.page__info__bannerimage.onlyshowDesk').querySelector('.action--unmute').classList.remove('hidden');
              document.querySelector('.page__info__bannerimage.onlyshowDesk').querySelector('.action--mute').classList.add('hidden');            
          }else if( target.target.closest('.page__info__bannerimage').classList.contains('onlyshowDesk') ){
              document.querySelector('.page__info__bannerimage.onlyshowMob').querySelector('video').muted = true;
              document.querySelector('.page__info__bannerimage.onlyshowMob').querySelector('.action--unmute').classList.remove('hidden');
              document.querySelector('.page__info__bannerimage.onlyshowMob').querySelector('.action--mute').classList.add('hidden');               
          }
          let targetVideo = target.target.closest('.page__info_media_interior').querySelector('video');
          targetVideo.play();
          target.currentTarget.classList.add('hidden');
          target.target.closest('.video__playIcon').querySelector('.action--pause').classList.remove('hidden');
      });
      elm?.querySelector('.action--pause')?.addEventListener('click', (target)=>{
          if ( target.target.closest('.page__info__bannerimage').classList.contains('onlyshowMob') ){
              document.querySelector('.page__info__bannerimage.onlyshowDesk').querySelector('video').muted = true;
              document.querySelector('.page__info__bannerimage.onlyshowDesk').querySelector('.action--unmute').classList.remove('hidden');
              document.querySelector('.page__info__bannerimage.onlyshowDesk').querySelector('.action--mute').classList.add('hidden');            
          }else if( target.target.closest('.page__info__bannerimage').classList.contains('onlyshowDesk') ){
              document.querySelector('.page__info__bannerimage.onlyshowMob').querySelector('video').muted = true;
              document.querySelector('.page__info__bannerimage.onlyshowMob').querySelector('.action--unmute').classList.remove('hidden');
              document.querySelector('.page__info__bannerimage.onlyshowMob').querySelector('.action--mute').classList.add('hidden');               
          }      
          target.preventDefault();
          let targetVideo = target.target.closest('.page__info_media_interior').querySelector('video');
          targetVideo.pause();
          target.currentTarget.classList.add('hidden');
          target.target.closest('.video__playIcon').querySelector('.action--play').classList.remove('hidden');
      })
      elm?.querySelector('.action--unmute')?.addEventListener('click', (target)=>{
          target.preventDefault();
          if ( target.target.closest('.page__info__bannerimage').classList.contains('onlyshowMob') ){
              document.querySelector('.page__info__bannerimage.onlyshowDesk').querySelector('video').muted = true;
              document.querySelector('.page__info__bannerimage.onlyshowDesk').querySelector('.action--unmute').classList.remove('hidden');
              document.querySelector('.page__info__bannerimage.onlyshowDesk').querySelector('.action--mute').classList.add('hidden');            
          }else if( target.target.closest('.page__info__bannerimage').classList.contains('onlyshowDesk') ){
              document.querySelector('.page__info__bannerimage.onlyshowMob').querySelector('video').muted = true;
              document.querySelector('.page__info__bannerimage.onlyshowMob').querySelector('.action--unmute').classList.remove('hidden');
              document.querySelector('.page__info__bannerimage.onlyshowMob').querySelector('.action--mute').classList.add('hidden');               
          }
          let targetVideo = target.target.closest('.page__info_media_interior').querySelector('video');
          targetVideo.muted = false;
          target.currentTarget.classList.add('hidden');
          target.target.closest('.video__muteUnmuteIcon').querySelector('.action--mute').classList.remove('hidden');          
      })  
      elm?.querySelector('.action--mute')?.addEventListener('click', (target)=>{
          target.preventDefault();
          if ( target.target.closest('.page__info__bannerimage').classList.contains('onlyshowMob') ){
              document.querySelector('.page__info__bannerimage.onlyshowDesk').querySelector('video').muted = true;
              document.querySelector('.page__info__bannerimage.onlyshowDesk').querySelector('.action--unmute').classList.remove('hidden');
              document.querySelector('.page__info__bannerimage.onlyshowDesk').querySelector('.action--mute').classList.add('hidden');            
          }else if( target.target.closest('.page__info__bannerimage').classList.contains('onlyshowDesk') ){
              document.querySelector('.page__info__bannerimage.onlyshowMob').querySelector('video').muted = true;
              document.querySelector('.page__info__bannerimage.onlyshowMob').querySelector('.action--unmute').classList.remove('hidden');
              document.querySelector('.page__info__bannerimage.onlyshowMob').querySelector('.action--mute').classList.add('hidden');               
          }
          let targetVideo = target.target.closest('.page__info_media_interior').querySelector('video');
          targetVideo.muted = true;
          target.currentTarget.classList.add('hidden');
          target.target.closest('.video__muteUnmuteIcon').querySelector('.action--unmute').classList.remove('hidden');                   
      })                 
  });
})